import { render, staticRenderFns } from "./ProductUpdate.vue?vue&type=template&id=dc8f43f8&scoped=true&"
import script from "./ProductUpdate.vue?vue&type=script&lang=js&"
export * from "./ProductUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ProductUpdate.vue?vue&type=style&index=0&id=dc8f43f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc8f43f8",
  null
  
)

export default component.exports